const en = {
  login: {
    usernamePlaceholder: 'Username or email',
    usernamePlaceholderArch: 'Email',
    fullName: 'Full name',
    password: 'Password',
    confirmPassword: 'Confirm password',
    passwordMismatch: 'Password and confirmation must match',
    invalidEmail: 'Invalid email',
    acceptPolicyPrefix: 'I agree to the',
    policyLinkText: 'personal data protection policy',
    signIn: 'Sign in',
    register: 'Register',
    registrationSuccessTitle: 'Registration successful.',
    registrationSuccessBody: 'Your account will be reviewed and activated by the site administrators.',
    switchToRegister: 'Register',
    switchToLogin: 'Sign in'
  }
}

export default en
